import React from 'react'
import Footer from '../../../general/footer/Footer';

import client2 from '../../../assets/client2.jpg'
import img2 from "../../../assets/img2.jpg";
import faimg1 from "../../../assets/faimg1.png"
import { Link } from 'react-router-dom';

const Fundraising = () => {
    return (
        <div>
            <div className="insurance-section">
                <div className="insurance-content">
                    <div className="breadcrumb">
                        <span>Home</span> &nbsp;•&nbsp;
                        <span>Our Services</span> &nbsp;•&nbsp;
                        <span className="active">Fundraising Assistance</span>
                    </div>
                    <h1>Fundraising Assistance</h1>
                    <p>
                        At PSJ Capital Ventures, we help founders and business owners raise funds strategically. Whether you’re an early-stage startup or a scaling business, we guide you through the end-to-end process, connecting you with the right investors, preparing your pitch, and structuring the deal for long-term success.
                    </p>
                </div>
                <div className="insurance-image">
                    <img src={faimg1} alt="Insurance Family" />
                </div>
            </div>

            <div className="travel-details-container">
                {/* LEFT SECTION */}
                <div className="travel-details-left">
                    <h2>What Is Fundraising Assistance?</h2>
                    <p>
                        Fundraising is the process of securing external capital to support business growth, product development, market expansion, or operational scaling. It can come in many forms, equity, debt, convertible instruments, or a combination, and requires not just access to capital, but the right kind of capital at the right time.
                    </p>

                    <h3 style={{ color: 'black' }}>Why Fundraising Matters</h3>

                    <h5>	•	Accelerate Business Growth</h5>
                    <p className="bold-line">
                        Capital can help you move faster, whether it’s for product launches, hiring, market entry, or tech upgrades.
                    </p>

                    <h5>•	Strengthen Financial Position</h5>
                    <p className="bold-line">
                        Well-structured fundraising improves cash flow and reduces pressure on internal resources.
                    </p>

                    <h5>•	Bring in Strategic Partners</h5>
                    <p className="bold-line">
                        Investors often bring more than money; they bring networks, expertise, and long-term guidance.
                    </p>

                    <h5>•	Fuel Innovation and Differentiation</h5>
                    <p className="bold-line">
                        External capital gives you the runway to innovate, take bold bets, and stay ahead of the competition.
                    </p>


                    <h3 style={{ color: 'black' }}>Why Choose PSJ Capital Ventures</h3>
                    <div className="plan-columns">

                        <div>
                            <h5>1. 	Founder-First Approach</h5>
                            <p>We align with your vision and ensure fundraising supports your business—not changes it.
                            </p>
                            <h5>2. 	Diverse Investor Network </h5>
                            <p>We work with early-stage VCs, angel networks, PE firms, NBFCs, and strategic investors across sectors.</p>
                        </div>
                        <div>
                            <h5>3. 	Deep Deal Experience </h5>
                            <p>We understand both sides of the table and help you close deals that are fair, future-ready, and founder-friendly.</p>
                            <h5>4.	Focus on Long-Term Value</h5>
                            <p>We’re not just focused on closing a round—we help you think about sustainable capital strategy for the long run.</p>
                        </div>
                    </div>

                    {/* Service Benefits */}
                    <div className="benefits-section">
                        <div className="benefits-image">
                            <img src={img2} alt="Service Benefits" />
                        </div>
                        <div className="benefits-list">
                            <h4>How We Help</h4>
                            {/* <p>
                                We help you invest across a wide spectrum of mutual fund categories:
                            </p> */}
                            <ul>
                                <li>✓ 	•	Capital Requirement Assessment  </li>
                                <li>✓ 	•	Investor Readiness Preparation </li>
                                <li>✓ 	•	Investor Identification and Introductions  </li>
                                <li> ✓	•   Deal Structuring and Advisory  </li>
                                <li> ✓  •	Ongoing Support Post-Funding  </li>
                            </ul>
                        </div>
                    </div>


                    {/* More Benefits */}
                    <div className="service-benefits">
                        <h3>Who Should Consider Fundraising Assistance?</h3>

                        <ul>
                            <li>✓	Early-stage startups building tech, consumer, or service-led products</li>
                            <li>✓ 	Growth-stage companies with strong traction seeking Series A or beyond</li>
                            <li>✓ 	SMEs looking for strategic debt or equity infusion</li>
                            <li>✓ 	Founders who want expert support in navigating a competitive investor landscape</li>
                        </ul>
                        <p>
                            Let’s Raise the Capital You Need to Grow
                            If you’re ready to raise funds, or even just exploring your options, we’re here to help you think through the process and take the next step with confidence.

                        </p>
                    </div>
                    <Link to='/contact'><button className="get-touch-btn">Get in Touch →</button></Link>
                </div>

                {/* RIGHT SECTION */}
                <div className="travel-details-right">
                    <div className="services-box">
                        <h4>Our Services</h4>
                        <ul>
                            <Link to='/mutual-funds'><li>Mutual Funds →</li></Link>
                            <Link to='/portfolio-management-services'><li>Portfolio Management Services →</li></Link>
                            <Link to='/macro-treasury-research'><li>Macro/Treasury Research →</li></Link>
                            <Link to='/nri-corner'><li>NRI Corner →</li></Link>
                            <Link to='/family-offices'><li>Family Offices →</li></Link>
                            <Link to='/insurance'><li>Insurance →</li></Link>
                            <Link to='/alternative-investment-funds'><li>Alternative Investment Funds →</li></Link>
                            <Link to='/loan-syndication'><li>Loan Syndication →</li></Link>
                            <Link to='/sme-ipo-advisory'><li>SME IPO Advisory →</li></Link>
                            <Link to='/stock-broking'><li>Stock Broking →</li></Link>
                        </ul>
                    </div>

                    <div className="advisor-box">
                        <img src={client2} alt="Advisor" />
                        <p>Make your dream life get professional help</p>
                        <div className="contact-info">
                            <span>📞 CONTACT US</span>
                            <p>+91 8108 430 942</p>
                        </div>
                    </div>
                </div>
            </div>
            <br></br><br></br><br></br>
            <Footer />
        </div>
    )
}

export default Fundraising
